module.exports = __webpack_public_path__ + "img/mk.5f02159e.svg";